import { Dash, Plus } from "react-bootstrap-icons";
import { useCart, useStore } from "../../hooks";
import { toAbsoluteUrl } from "../../helpers";
import { StoreProductModel } from "../../models";
import { formatCurrency } from "../../utilities";

type Props = {
  products: StoreProductModel[];
};

export const CrossSellProduct: React.FC<Props> = ({ products }) => {
  const { menuId } = useStore();
  const { isProductExists, addToCart, decreaseQuantity } = useCart();

  return (
    <>
      <div className="complete_meal_sec">
        <h3>
          Complete Your Meal <span>Here are some popular add-ons.</span>
        </h3>
        <div className="row g-3 mb-3">
          {products.map((product, key) => (
            <div key={key} className="col-12 col-md-6 d-flex">
              <div className="complete_row1 h-100 w-100">
                <span>
                  <img
                    src={
                      product.product_image
                        ? product.product_image
                        : toAbsoluteUrl("images/av5c.png")
                    }
                    alt=""
                  />
                </span>
                <div className="px-2 flex-grow-1">
                  <h4>{product.product_name}</h4>
                  <p>{product.product_desc}</p>
                  <h5>{formatCurrency(product.product_price)}</h5>
                </div>
                <span className="d-flex flex-row align-items-center gap-2">
                  {isProductExists(product.id) && (
                    <button
                      className="p-1"
                      onClick={() => decreaseQuantity(product.id)}
                    >
                      <Dash size={30} />
                    </button>
                  )}
                  {!isProductExists(product.id) && (
                    <button
                      className="p-1"
                      onClick={() => addToCart(product, 1, [], "", menuId)}
                    >
                      <Plus size={30} />
                    </button>
                  )}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
